import React, { useState } from 'react';
import { PlusIcon, MinusIcon } from 'lucide-react';
const faqs = [{
  q: 'Est-ce sûr pour la confidentialité des clients ?',
  a: 'Oui, notre guide inclut un protocole « Privacy First » pour garantir qu’aucune donnée sensible (PII) ne soit compromise.'
}, {
  q: 'Dois-je être un expert en technologie ?',
  a: 'Non. Si vous savez copier et coller, vous savez utiliser ce système.'
}, {
  q: 'Est-ce un paiement unique ?',
  a: 'Oui. Aucun abonnement caché.'
}];
export function FAQ() {
  const [open, setOpen] = useState<number | null>(0);
  return <section aria-label="Questions fréquentes" className="bg-transparent" data-id="element-41" data-mp="2039mc443xc9w">
      <div className="mx-auto max-w-3xl px-5 py-12" style={{
      paddingTop: "14px",
      paddingBottom: "14px"
    }} data-id="element-42" data-mp="1v4zpzq6nc5mp">
        <h2 className="text-center font-display text-3xl font-black text-plum sm:text-4xl" data-id="element-43" data-mp="oonr1mw02jq2">
          ❓ Questions Fréquentes
        </h2>
        <div className="mt-10 divide-y divide-grape/10 overflow-hidden rounded-2xl border border-grape/15 bg-white" data-id="element-44" data-mp="jp1cna4fqxfo">
          {faqs.map((f, i) => {
          const isOpen = open === i;
          return <div key={f.q} data-id="element-45" data-mp="1pls0lzmnrbcb" data-mpi={i}>
                <button type="button" onClick={() => setOpen(isOpen ? null : i)} aria-expanded={isOpen} className="flex w-full items-center justify-between gap-4 px-6 py-5 text-left transition-colors duration-150 ease-out hover:bg-lilac-soft focus:outline-none focus-visible:bg-lilac-soft" data-id="element-46" data-mp="1pm1rdpfj1mj2">
                  <span className="text-sm font-bold text-plum sm:text-base" data-id="element-47" data-mp="11vo0w3clbvql">{f.q}</span>
                  {isOpen ? <MinusIcon className="h-5 w-5 shrink-0 text-blush" data-id="element-48" data-mp="16pidkmts3ag6" /> : <PlusIcon className="h-5 w-5 shrink-0 text-plum/40" data-id="element-49" data-mp="rzkx6t23bp1j" />}
                </button>
                <div className="grid transition-[grid-template-rows] duration-300 ease-out" style={{
              gridTemplateRows: isOpen ? '1fr' : '0fr'
            }} data-id="element-50" data-mp="wxmfhbrozkby">
                  <div className="overflow-hidden" data-id="element-51" data-mp="j0hbrifgaxjv">
                    <p className="px-6 pb-5 text-sm leading-relaxed text-plum/70" data-id="element-52" data-mp="mywvndg8jpt2">{f.a}</p>
                  </div>
                </div>
              </div>;
        })}
        </div>
      </div>
    </section>;
}